<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="storm-clouds">
<p style="margin-top: 250px; text-align: center;">“I Fall to Pieces.”</p><br/>
<p style="text-align: right;">Patsy Cline</p>
<p style="text-align: right;">Kansas City, Kansas</p>
<p style="text-align: right;">March 5, 1963</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?bdf896b4